import {common} from "../../../global/common.js";
import {api} from "../../../global/framework/api.js";
import {notifications} from "../../../global/notifications.js";

const ENTITY_CONFIG = {
    ASSOCIATION: new EntityConfig(1, null, "Network", "association"),
    CLINIC: new EntityConfig(2, 1, "Clinic", "clinic"),
    PHYSICIAN: new EntityConfig(3, 2, "Physician", "physician")
};

function EntityConfig(id, parentTypeId, name, role) {
    this.typeId = id;
    this.parentTypeId = parentTypeId;
    this.name = name;
    this.role = role;
}

export const providerUtilities = {
    ENTITY_CONFIG,
    getByEntityTypeId(typeId) {
        for (let current in ENTITY_CONFIG) {
            if (ENTITY_CONFIG[current].typeId === typeId) {
                return ENTITY_CONFIG[current];
            }
        }
    },
    getConfigByParent(typeId) {
        for (let current in ENTITY_CONFIG) {
            if (ENTITY_CONFIG[current].parentTypeId === typeId) {
                return ENTITY_CONFIG[current];
            }
        }
    },
    async switchRoles(newProviderEntityId) {
        let authToken = await api.get('ProviderEntity', newProviderEntityId, "GetRoleToken");
        try {
            let newTokenResponse = await $.ajax({
                type: "POST",
                disablePrefilter: true,
                disableBeforeSendHandler: true,
                url: common.APP_CONFIG.ROOT_URL + "AcressaOAuth/token",
                data: {
                    grant_type: "password",
                    client_id: "AcressaJsApp",
                    providerEntityId: newProviderEntityId,
                    tempAuthToken: authToken.tempToken,
                    associatedUserId: authToken.userId,
                    impersonator: authToken.impersonator
                }
            });
            if (newTokenResponse) {
                window.localStorage.removeItem("acressaToken");
                localStorage.acressaToken = 'Bearer ' + newTokenResponse.access_token;
                window.location.href = "/" + newTokenResponse.roleName.toLowerCase() + "/#/" + newTokenResponse.entityId + "/dashboard";
            } else {
                throw Error(newTokenResponse);
            }
        } catch (e) {
            notifications.show({title: "Unable to switch providers", message: e.toString()}, common.ACRESSA_NOTIFICATIONS.ERROR);
        }

    },
    getAgeRange(plan) {
        let val = "";
        let hasMinAge = !!plan.minAge;
        let hasMaxAge = !!plan.maxAge;

        if (hasMinAge && !hasMaxAge)
            val = "FOR AGES " + plan.minAge + " AND UP";

        if (!hasMinAge && hasMaxAge)
            val = "FOR AGES " + plan.maxAge + " AND UNDER";

        if (hasMinAge && hasMaxAge)
            val = "FOR AGES " + plan.minAge + " TO " + plan.maxAge;

        if (!hasMinAge && !hasMaxAge)
            val = "FOR ALL AGES";

        return val;
    }
};